import formatLogString from './formatLogString'
import logString from './logString'
import getLogger from './getLogger'

const l = getLogger()

export { formatLogString, logString, getLogger, l }
